import { TutorialStepBgStyled, TutorialStepControlsStyled, TutorialStepStyled, TutorialStepTitleStyled } from "./TutorialStepStyled"

const TutorialKey = ({ keyName }) => {
  const isLong = keyName.length > 1;
  return <div className={'tutorial-key' + (isLong ? ' long' : '') }><i>{keyName}</i></div>
}

const TutorialArrowKey = ({ arrow }) => {
  const chars = {
    'left': '←',
    'right': '→',
    'up': '↑',
    'down': '↓',
  }
  return <div className="tutorial-key arrow">{chars[arrow]}</div>
}

 const renderControlsPart = ({ type, content }, index) => {
    switch (type) {
      case 'text':
        return <div key={index} className="key-text">{content}</div>;
        case 'combo':
          return <span key={index} className="key-combo">→</span>;
      case 'key':
        return <TutorialKey key={index} keyName={content}/>;
      case 'arrow':
        return <TutorialArrowKey key={index} arrow={content}/>;
    }  
 }
  
const TutorialControls = ({ keys }) => {
  // Split to keys and text
  const textParts = [];
  const addTextPart = (text) => {
    if(text.trim() === '-') { 
      textParts.push({ type: 'combo'});
    } else if (text.substring(text.length - 3) === ' - ') {
      textParts.push({ type: 'text', content: text.substring(0, text.length - 3) });
      textParts.push({ type: 'combo'});
    } else {
      textParts.push({ type: 'text', content: text });
    }
  }

  const parts = keys.split('#');
  parts.forEach(element => {
    if (!element.length) {
      return;
    }
    // Key placeholder found
    if (element.startsWith('{') && element.indexOf('}') !== -1) {
      const keyEnd = element.indexOf('}');
      const keyName = element.substring(1, keyEnd);
      if (keyName.length) {
        const arrowPrefix = 'arrow-';
        if (keyName.startsWith('arrow-')) {
          textParts.push({ type: 'arrow', content: keyName.substring(arrowPrefix.length) });
        } else {
          textParts.push({ type: 'key', content: keyName });
        }
      }

      const textContentAfter = element.substring(keyEnd + 1);
      if (textContentAfter.length > 0) {
        addTextPart(textContentAfter);
      }
    } else {
      addTextPart(element);
    }
  });

  return (<div className="key">
    {textParts.map((part, i) => renderControlsPart(part, i) )}
  </div>)
};

export const TutorialStep = ({ title, text, controls, image }) => {
  return (
    <TutorialStepStyled>
      <TutorialStepTitleStyled>{title}</TutorialStepTitleStyled>
      {
        controls.map(({ keys, description }) => <div key={keys} className="key-definition">
          <TutorialControls keys={keys}/>
          <div className="key-action">{description}</div>
        </div>)
      }
      {text && <div className='tutorial-subtitle'>{text}</div>}
      { image && <div className="tutorial-image">
        <img src={image} />
      </div>
      }
      
    </TutorialStepStyled>
  )
}